import { Selector } from '../../lib/generated/zeus';
import { relatedNoteSelector } from './note';

export const rosterShiftSelector = Selector('RosterShift')({
  id: true,
  rootId: true,
  startTime: true,
  endTime: true,
  status: true,
  recordStatus: true,
  relatedNotes: relatedNoteSelector,
  isRecurring: true,
  recurrenceEndDate: true,
  recurrencePattern: true,
  isDerived: true,
  originalShiftId: true,
  createdAt: true,
  createdBy: true,
});

export const roleRosterSelector = Selector('RoleRoster')({
  teamRoleAssignmentId: true,
  roleId: true,
  roleName: true,
  roleGroup: true,
  vacantShifts: rosterShiftSelector,
  users: {
    userId: true,
    firstName: true,
    lastName: true,
    email: true,
    phoneNumber: true,
    externalId: true,
    userRoleAssignmentId: true,
    username: true,
    userType: true,
    shifts: rosterShiftSelector,
    historic: true,
  },
});

export const teamRosterSelector = Selector('TeamRoster')({
  teamId: true,
  teamName: true,
  teamType: true,
  teamRecordStatus: true,
  internalOrderNumber: true,
  costObjectDescription: true,
  roleRosters: roleRosterSelector,
  dayShiftPeriod: {
    start: true,
    end: true,
  },
});

export const queryRosterResponseSelector = Selector('QueryRosterResponse')({
  message: true,
  data: teamRosterSelector,
});
